import { render, staticRenderFns } from "./Reglamentos-lineamientos.vue?vue&type=template&id=001d9ae0&scoped=true"
import script from "./Reglamentos-lineamientos.vue?vue&type=script&lang=js"
export * from "./Reglamentos-lineamientos.vue?vue&type=script&lang=js"
import style0 from "./Reglamentos-lineamientos.vue?vue&type=style&index=0&id=001d9ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001d9ae0",
  null
  
)

export default component.exports